module.exports = __webpack_public_path__ + "img/esia.3050c81e.svg";